import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import SpecialPricing from '../AcrylicColor/SpecialPricing'; // Adjust the path if located elsewhere
import Pricing from '../AcrylicColor/price.js'; // Adjust if located elsewhere

const AddAcrylicColor = () => {
  const [isLotRequired, setIsLotRequired] = useState(false);
  const [allowNoteForLot, setAllowNoteForLot] = useState(false);
  const [isSerialRequired, setIsSerialRequired] = useState(false);
  const [allowNoteForSerial, setAllowNoteForSerial] = useState(false);
  const [allSpecial, setAllSpecial] = useState([]);
  const [value, setValue] = useState('');
  const [pricingData, setPricingData] = useState({});

  

  // Handlers
  const handleLotRequiredChange = (e) => {
    setIsLotRequired(e.target.checked);
    if (!e.target.checked) setAllowNoteForLot(false);
  };

  const handleSerialRequiredChange = (e) => {
    setIsSerialRequired(e.target.checked);
    if (!e.target.checked) setAllowNoteForSerial(false);
  };
  
  const handleValueChange = (e) => {
    setValue(e.target.value);
  };

  const handleDataUpdate = (data) => {
  
    setPricingData(data);
  };

  const handleRowsUpdate = (rows) => {
    
    setAllSpecial(rows);
  };


  // Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const inputData = {
      valueName: value,
      isLotRequired,
      allowNoteForLot,
      isSerialRequired,
      allowNoteForSerial,
      pricing: pricingData,
      specialPricing: allSpecial,
    };
  
    
  
    try {
      const response = await fetch('https://hms.backend.hiragroupcloud.com/api/addAcrylicColor', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(inputData),
      });
  
      if (response.ok) {
        await response.json(); // removed unused variable
        
      } else {
        console.error('Error submitting form:', response.statusText);
      }
    } catch (error) {
      console.error('Network error:', error);
    }
  };
  

  // Styling
  const boldStyle = { fontWeight: 'bold' };

  return (
    <>
           <div style={{width:"1600px"}}>   
                <h2 >
                  Add  Acrylic Color
                  </h2>
                <h3 style={{color:"#004aad"}}>
                  Details
                </h3>
                <form className="p-4 "  onSubmit={handleSubmit}>
                  <div style={{borderTop:"2px solid #004aad",backgroundColor:"#f4f4f4",padding:"10px"}}>
                  <div className="mb-3">
                    <label className="form-label" 
                    style={boldStyle}>
                      Value Name *
                      </label>
                    <input type="text" 
                    className="form-control"
                     placeholder="Enter Value Name" 
                     onChange={handleValueChange} 
                     value={value} />
                  </div>
                  <div className="mb-3" 
                  style={{ display: 'flex', alignItems: 'center' }}>
                    <label className="form-label" 
                    style={boldStyle}>
                      Lot #
                    </label>
                    <div className="form-check" 
                    style={{ marginLeft: ' 12%' }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={isLotRequired}
                        onChange={handleLotRequiredChange}
                      />
                      <label 
                      className="form-check-label">
                        Is Required
                        </label>
                    </div>
                    <div className="form-check" 
                    style={{ marginLeft: '10px' }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={allowNoteForLot}
                        onChange={(e) => setAllowNoteForLot(e.target.checked)}
                        disabled={!isLotRequired}
                      />
                      <label className="form-check-label">Allow Note</label>
                    </div>
                  </div>
                  <div className="mb-3" style={{ display: 'flex', alignItems: 'center' }}>
                    <label className="form-label" style={boldStyle}>Serial #</label>
                    <div className="form-check" style={{ marginLeft: ' 10%' }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={isSerialRequired}
                        onChange={handleSerialRequiredChange}
                      />
                      <label className="form-check-label">Is Required</label>
                    </div>
                    <div className="form-check" style={{ marginLeft: '10px' }}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={allowNoteForSerial}
                        onChange={(e) => setAllowNoteForSerial(e.target.checked)}
                        disabled={!isSerialRequired}
                      />
                      <label className="form-check-label">Allow Note</label>
                    </div>
                  </div>
                  </div>
                
                {/* Pricing and Special Pricing Components */}
                <Pricing onDataUpdate={handleDataUpdate} />
                <SpecialPricing onRowsUpdate={handleRowsUpdate} />

                <div style={{ marginTop: '10px', textAlign: 'left' }}>
                  <button className="btn btn-success" type="submit" style={{borderColoer:"#004aad", backgroundColor:"#004aad"}}>Save</button>
                </div>
              </form>
              </div>
            
    </>
  );
};

export default AddAcrylicColor;
